import { useMemo, useState } from "react";
import { Controller } from "react-hook-form";
import { FaSearch, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { clinicMenus } from "../../home/MenuList";

const GlobalSearchSmart = ({
  control,
  name,
  placeholder = "Search...",
  className = "",
}) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const menuMatches = useMemo(() => {
    const q = (inputValue || "").trim().toLowerCase();
    if (!q) return [];
    return clinicMenus.filter((m) => m.title.toLowerCase().includes(q));
  }, [inputValue]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={() => (
        <div className={`relative ${className}`}>
          <div className="relative flex items-center">
            <FaSearch className="absolute left-3 text-gray-400 text-sm pointer-events-none" />
            <input
              type="text"
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
                setIsOpen(true);
              }}
              onFocus={() => setIsOpen(true)}
              onBlur={() => setTimeout(() => setIsOpen(false), 150)}
              placeholder={placeholder}
              className="w-full pl-9 pr-9 py-2 text-sm border border-gray-200 rounded-xl bg-white focus:outline-none focus:border-[#217E90] focus:ring-1 focus:ring-[#217E90]"
            />
            {inputValue && (
              <button
                type="button"
                className="absolute right-3 text-gray-400 hover:text-gray-600"
                onClick={() => {
                  setInputValue("");
                  setIsOpen(false);
                }}
              >
                <FaTimes className="text-sm" />
              </button>
            )}
          </div>
          {isOpen && menuMatches.length > 0 && (
            <ul className="absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-auto">
              {menuMatches.map((item) => (
                <li key={item.path}>
                  <button
                    type="button"
                    className="w-full text-left px-3 py-2 text-sm hover:bg-[#E9F5FE] text-gray-700"
                    onMouseDown={() => {
                      navigate(item.path);
                      setInputValue("");
                      setIsOpen(false);
                    }}
                  >
                    {item.title}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    />
  );
};

export default GlobalSearchSmart;
